import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MaterialModule } from '../material/material.module';
import { NoNetworkDialogBodyComponent } from './notifications/no-network/no-network-dialog-body/no-network-dialog-body.component';
import { NoNetworkDialogComponent } from './notifications/no-network/no-network-dialog/no-network-dialog.component';
import { NoServerDialogBodyComponent } from './notifications/no-server/no-server-dialog-body/no-server-dialog-body.component';
import { NoServerDialogComponent } from './notifications/no-server/no-server-dialog/no-server-dialog.component';

@NgModule({
    declarations: [
        NoNetworkDialogComponent,
        NoNetworkDialogBodyComponent,
        NoServerDialogComponent,
        NoServerDialogBodyComponent
    ],
    imports: [CommonModule, MaterialModule],
    exports: [
        NoNetworkDialogComponent,
        NoNetworkDialogBodyComponent,
        NoServerDialogComponent,
        NoServerDialogBodyComponent
    ]
})
export class ServerCommunicationModule {}
